import React from 'react';
import { DocumentArchive, UserArchive } from '../components';
import { ADMIN, CLIENT } from '../services';

function Archives(): React.ReactElement {
   
    return (
        <div>
            <DocumentArchive roleId={CLIENT} title="Document Archive" />
            <UserArchive roleId={CLIENT} title="User Archive" />
        </div>
    );
}

export default Archives;
